import type { FilterValue } from '../../redux/common_filters/types';

export function guardFilterString(
  filterValue: FilterValue,
): string | undefined {
  if (typeof filterValue === 'string') {
    return filterValue;
  }
  return undefined;
}
